
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import CountDown from '@/components/countdown/index.vue';
import BackTop from '@/common/backtop.vue';
// import {
//   aliPayPc, orderDetail, pageVisit, getDataCard,
//   getDataBanner,
//   getDataReCommend,
//   getDataProType
// } from '@/services/http';

@Component({
  components: {
    Header,
    Footer,
    CountDown,
    BackTop
  }
})
export default class extends Vue {
  // 活动结束倒计时5s
  countdown: number = 5;

  timer: any = '';

  created() {
    // this.goHomePage();
  }

  goHomePage() {
    this.timer = setInterval(() => {
      this.countdown -= 1;
      if (this.countdown === 0) {
        this.$router.push('/');
        clearInterval(this.timer);
      }
    }, 1000);
  }
}
